<template>
    <div style="border-radius: 4px; overflow: hidden;">
        <chartTitle style="padding-bottom: 0;">
            Risk Quotient (RQ) Distribution
        </chartTitle>

        <barChart ref="barchart" :barChartData="rq.barChartData" :height="height - 10" @loading="$emit('loading')"
            @loaded="$emit('loaded')">
        </barChart>
    </div>
</template>

<script>
    import chartTitle from './base/chartTitle.vue'

    export default {
        components: {
            barChart: () => import('./base/barChart.vue'),
            chartTitle,
        },

        props: {
            rq: {
                required: false,
                //type: TODO: add I_RQ here. 
            },
            height: {
                type: Number,
                default: 300
            }
        },
    }

</script>